/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Button, Tooltip } from "@nordcloud/gnui";
import { Customer } from "~/components/BasicCustomerInfo/types";
import { StyledOutsideLink } from "~/components/Styled/Common";
import { Application } from "~/models";
import { ROUTES } from "~/routing";

type Props = {
  application: Application;
  customer: Customer;
};

const RunbookLink = styled(Link)`
  display: inline-block;
  width: 120px;
  text-decoration: none;
  margin-right: 8px;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

const RunbookName = styled.span`
  position: relative;
  top: -2px;
`;

function InlineCustomerRunbook({ customer, application }: Props) {
  const runbookUrl = `${ROUTES.customers.index}/${customer.id}/applications/${application.id}/runbook`;
  const runbookDisabledTooltip =
    "Runbook is disabled because the runbook location or runbook to include is not set.";

  const disableRunbookGeneration =
    !application.runbookLocation || !application.existingRunbookInclude;

  const runbookButton = (
    <Button
      size="md"
      icon={application.runbook ? "edit" : "plus"}
      css={{ width: "100%", justifyContent: "center" }}
      disabled={disableRunbookGeneration}
    >
      {application.runbook ? "Edit" : "Create"}
    </Button>
  );

  return disableRunbookGeneration ? (
    <div>
      <RunbookLink to={runbookUrl}>
        <Tooltip
          status="warning"
          caption={runbookDisabledTooltip}
          hideTimeout={0}
        >
          {runbookButton}
        </Tooltip>
      </RunbookLink>
    </div>
  ) : (
    <div>
      <RunbookLink to={runbookUrl}>{runbookButton}</RunbookLink>
      {application.runbook && (
        <RunbookName>
          <StyledOutsideLink href={application.runbook.url}>
            {application.runbook.name}
          </StyledOutsideLink>
        </RunbookName>
      )}
    </div>
  );
}

export { InlineCustomerRunbook };
